var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bottom-line-provenance" }, [
    _vm.showPageTitle || _vm.showLinkBack
      ? _c("div", { staticClass: "page-heading" }, [
          _vm.showPageTitle
            ? _c("h2", { staticClass: "page-title" }, [
                _vm._v("Bottom-Line Provenance"),
              ])
            : _vm._e(),
          _vm.documentationMap
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    gap: "15px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-body temporary-card" },
                    [
                      _c("documentation", {
                        attrs: {
                          name: "bottomline.provenance.tooltip",
                          "content-map": _vm.documentationMap,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "provenance-page-link",
                      attrs: { href: _vm.standaloneProvenanceUrl },
                    },
                    [_vm._v(" View full provenance page ")]
                  ),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm.showSearch
      ? _c(
          "div",
          {
            ref: "traitPicker",
            staticClass: "trait-picker",
            class: { "has-selection": !!_vm.selectedAncestry },
          },
          [
            _c("div", { staticClass: "search-control" }, [
              _c("div", { staticClass: "search-label" }, [_vm._v("Search")]),
              _c("div", { staticClass: "search-input-wrap" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchText,
                      expression: "searchText",
                    },
                  ],
                  staticClass: "form-control trait-search",
                  attrs: {
                    id: "bottom_line_trait_search",
                    type: "text",
                    autocomplete: "off",
                    placeholder: "trait name",
                  },
                  domProps: { value: _vm.searchText },
                  on: {
                    focus: _vm.openTraitList,
                    click: _vm.openTraitList,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchText = $event.target.value
                    },
                  },
                }),
                _vm.selectedAncestry && _vm.listExpanded
                  ? _c(
                      "button",
                      {
                        staticClass: "clear-search",
                        attrs: {
                          type: "button",
                          "aria-label": "Clear search and close trait list",
                          title: "Clear search and close trait list",
                        },
                        on: { click: _vm.clearAndCloseTraitList },
                      },
                      [_vm._v(" × ")]
                    )
                  : _vm._e(),
              ]),
              _c("span", { staticClass: "trait-count" }, [
                _vm._v(_vm._s(_vm.traitCountLabel)),
              ]),
            ]),
            _vm.traitError
              ? _c("div", { staticClass: "alert alert-danger mt-3 mb-0" }, [
                  _vm._v(" " + _vm._s(_vm.traitError) + " "),
                ])
              : _vm._e(),
            _vm.showTraitList
              ? _c(
                  "div",
                  {
                    staticClass: "trait-list",
                    class: { "dropdown-list": !!_vm.selectedAncestry },
                  },
                  [
                    _vm._m(0),
                    _vm.loadingTraits
                      ? _c("div", { staticClass: "trait-list-status" }, [
                          _vm._v(" Loading traits... "),
                        ])
                      : _vm.filteredTraits.length === 0
                      ? _c("div", { staticClass: "trait-list-status" }, [
                          _vm._v(" No traits match this search. "),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.filteredTraits, function (trait) {
                      return _c(
                        "div",
                        {
                          key: _vm.traitKey(trait),
                          staticClass: "trait-list-item",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "trait-name",
                              attrs: {
                                type: "button",
                                title: "View Mixed ancestry provenance",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectDefaultAncestry(trait)
                                },
                                mouseenter: function ($event) {
                                  _vm.hoveredTraitKey = _vm.traitKey(trait)
                                },
                                mouseleave: function ($event) {
                                  _vm.hoveredTraitKey = ""
                                },
                                focus: function ($event) {
                                  _vm.hoveredTraitKey = _vm.traitKey(trait)
                                },
                                blur: function ($event) {
                                  _vm.hoveredTraitKey = ""
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.highlightTraitName(trait)
                                  ),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "ancestry-pill-group" },
                            _vm._l(
                              _vm.traitAncestries(trait),
                              function (ancestry) {
                                return _c(
                                  "button",
                                  {
                                    key: ancestry.id || ancestry.ancestry_id,
                                    staticClass: "ancestry-pill",
                                    class: {
                                      "highlighted-default":
                                        _vm.hoveredTraitKey ===
                                          _vm.traitKey(trait) &&
                                        _vm.isMixedAncestry(ancestry),
                                    },
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectAncestry(
                                          trait,
                                          ancestry
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ancestry.ancestry_name ||
                                            ancestry.ancestry_id ||
                                            "Unknown"
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm.selectedTrait
      ? _c(
          "div",
          { staticClass: "provenance-detail" },
          [
            _c("div", { staticClass: "detail-header" }, [
              _c("div", [
                _c("div", { staticClass: "metadata-label" }, [_vm._v("trait")]),
                _c("h3", [_vm._v(_vm._s(_vm.selectedTitle))]),
              ]),
              _vm.loadingProvenance
                ? _c("div", { staticClass: "detail-loading" }, [
                    _vm._v(" Loading provenance... "),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "selected-ancestry-group" }, [
              _c("div", { staticClass: "ancestry-actions" }, [
                _c("div", { staticClass: "ancestry-selector-group" }, [
                  _c("div", { staticClass: "metadata-label" }, [
                    _vm._v(" selected ancestry "),
                    _vm.showAncestrySelect
                      ? _c("span", { staticClass: "results-ancestry" }, [
                          _vm._v("— click to select"),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "ancestry-switcher" },
                    _vm._l(
                      _vm.visibleSelectedTraitAncestries,
                      function (ancestry) {
                        return _c(
                          "button",
                          {
                            key: ancestry.id || ancestry.ancestry_id,
                            staticClass: "ancestry-pill",
                            class: {
                              selected: _vm.isSelectedAncestry(ancestry),
                            },
                            attrs: {
                              type: "button",
                              disabled: !_vm.showAncestrySelect,
                            },
                            on: {
                              click: function ($event) {
                                _vm.showAncestrySelect &&
                                  _vm.selectAncestry(
                                    _vm.selectedTrait,
                                    ancestry
                                  )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  ancestry.ancestry_name ||
                                    ancestry.ancestry_id ||
                                    "Unknown"
                                ) +
                                " "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]),
                _vm.bottomLineResultsUrl
                  ? _c(
                      "div",
                      { staticClass: "download-results-group" },
                      [
                        _c("div", { staticClass: "metadata-label" }, [
                          _vm._v(" bottom-line results "),
                          _c("span", { staticClass: "results-ancestry" }, [
                            _vm._v(
                              "— " +
                                _vm._s(
                                  _vm.selectedAncestry.ancestry_name ||
                                    _vm.selectedAncestry.ancestry_id
                                )
                            ),
                          ]),
                        ]),
                        _c(
                          "b-button",
                          {
                            staticClass: "download-results-button",
                            attrs: {
                              variant: "primary",
                              href: _vm.bottomLineResultsUrl,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [
                            _c("b-icon-download", {
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" Download summary statistics "),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
            !_vm.selectedAncestry
              ? _c("p", { staticClass: "ancestry-selection-note" }, [
                  _vm._v(" Select an ancestry to view its provenance. "),
                ])
              : _vm._e(),
            _vm.provenanceError
              ? _c("div", { staticClass: "alert alert-danger mt-3" }, [
                  _vm._v(" " + _vm._s(_vm.provenanceError) + " "),
                ])
              : _vm._e(),
            _vm.selectedProvenance
              ? [
                  _vm.selectedProvenance.description
                    ? _c("div", { staticClass: "provenance-description" }, [
                        _c("span", { staticClass: "metadata-label" }, [
                          _vm._v("description"),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.selectedProvenance.description)),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "provenance-metadata-row" }, [
                    _c("div", { staticClass: "metadata-field" }, [
                      _c("span", { staticClass: "metadata-label" }, [
                        _vm._v("pipeline_type"),
                      ]),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          id: "bottom_line_pipeline_type",
                          type: "text",
                          readonly: "",
                        },
                        domProps: {
                          value:
                            _vm.selectedProvenance.pipeline_type ||
                            "Unavailable",
                        },
                        on: {
                          focus: function ($event) {
                            return $event.target.select()
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "metadata-field" }, [
                      _c("span", { staticClass: "metadata-label" }, [
                        _vm._v("trait_legacy_id"),
                      ]),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          id: "bottom_line_trait_legacy_id",
                          type: "text",
                          readonly: "",
                        },
                        domProps: {
                          value:
                            _vm.selectedProvenance.trait_legacy_id ||
                            "Unavailable",
                        },
                        on: {
                          focus: function ($event) {
                            return $event.target.select()
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "metadata-field" }, [
                      _c("span", { staticClass: "metadata-label" }, [
                        _vm._v("ancestry_id"),
                      ]),
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          id: "bottom_line_ancestry_id",
                          type: "text",
                          readonly: "",
                        },
                        domProps: {
                          value:
                            _vm.selectedProvenance.ancestry_id || "Unavailable",
                        },
                        on: {
                          focus: function ($event) {
                            return $event.target.select()
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "metadata-field" }, [
                      _c(
                        "label",
                        {
                          staticClass: "metadata-label",
                          attrs: { for: "bottom_line_provenance_link" },
                        },
                        [_vm._v(" provenance data link ")]
                      ),
                      _c("div", { staticClass: "link-copyable-input" }, [
                        _c("input", {
                          staticClass: "form-control",
                          attrs: {
                            id: "bottom_line_provenance_link",
                            type: "text",
                            readonly: "",
                          },
                          domProps: { value: _vm.selectedProvenanceLink },
                          on: {
                            focus: function ($event) {
                              return $event.target.select()
                            },
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "copy-icon-button",
                            attrs: {
                              type: "button",
                              "aria-label": "Copy provenance graph data link",
                              title: "Copy provenance graph data link",
                            },
                            on: { click: _vm.copyProvenanceLink },
                          },
                          [
                            _vm.copyMessage === "Copied."
                              ? _c("b-icon-check")
                              : _c("b-icon-clipboard"),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm.copyMessage && _vm.copyMessage !== "Copied."
                    ? _c("div", { staticClass: "copy-message" }, [
                        _vm._v(_vm._s(_vm.copyMessage)),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "code-box-group" },
                    [
                      _c("div", { staticClass: "metadata-label" }, [
                        _vm._v("provenance data"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "provenance-tabs",
                          attrs: {
                            role: "tablist",
                            "aria-label": "Provenance data view",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "provenance-tab",
                              class: { active: _vm.provenanceView === "graph" },
                              attrs: {
                                type: "button",
                                role: "tab",
                                "aria-selected": _vm.provenanceView === "graph",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.provenanceView = "graph"
                                },
                              },
                            },
                            [_vm._v(" Graph ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "provenance-tab",
                              class: { active: _vm.provenanceView === "table" },
                              attrs: {
                                type: "button",
                                role: "tab",
                                "aria-selected": _vm.provenanceView === "table",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.provenanceView = "table"
                                },
                              },
                            },
                            [_vm._v(" Table ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "provenance-tab",
                              class: { active: _vm.provenanceView === "json" },
                              attrs: {
                                type: "button",
                                role: "tab",
                                "aria-selected": _vm.provenanceView === "json",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.provenanceView = "json"
                                },
                              },
                            },
                            [_vm._v(" JSON ")]
                          ),
                        ]
                      ),
                      _vm.provenanceView === "json"
                        ? _c("div", { staticClass: "provenance-code-wrap" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "copy-icon-button provenance-json-copy",
                                attrs: {
                                  type: "button",
                                  "aria-label": "Copy provenance JSON",
                                  title: "Copy provenance JSON",
                                },
                                on: { click: _vm.copyProvenanceJson },
                              },
                              [
                                _vm.copiedProvenanceJson
                                  ? _c("b-icon-check")
                                  : _c("b-icon-clipboard"),
                              ],
                              1
                            ),
                            _c("pre", { staticClass: "provenance-code" }, [
                              _c("code", [
                                _vm._v(_vm._s(_vm.formattedProvenanceJson)),
                              ]),
                            ]),
                          ])
                        : _vm.provenanceView === "table"
                        ? _c("provenance-table", {
                            attrs: {
                              provenance: _vm.selectedProvenance.provenance,
                            },
                          })
                        : _c("provenance-graph", {
                            attrs: {
                              provenance: _vm.selectedProvenance.provenance,
                            },
                          }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "trait-list-columns" }, [
      _c("span", [_vm._v("Traits")]),
      _c("span", [_vm._v("Ancestries")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }